import React from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: any;
  footer?: any;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'huge';
}

const Modal = ({ isOpen, onClose, title, children, footer, size = 'md' }: ModalProps) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'max-w-sm';
      case 'md':
        return 'max-w-md';
      case 'lg':
        return 'max-w-lg';
      case 'xl':
        return 'max-w-xl';
      case 'huge':
        return 'max-w-7xl w-full mx-4';
      default:
        return 'max-w-md';
    }
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className={`bg-white rounded-xl shadow-lg ${getSizeClasses()} w-full p-4 sm:p-6 max-h-[90vh] overflow-y-auto relative`}>
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close modal"
        >
          <X size={24} />
        </button>
        {title && <h3 className="text-xl font-bold mb-6 pr-8">{title}</h3>}
        <div>{children}</div>
        {footer && <div className="mt-6 flex justify-end space-x-3">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal; 